import { NICmsContentComponent } from '@icms/core/content';

export interface IModelCarouselData extends NICmsContentComponent.IData, IModelCarouselLoadRequest {
    title: string;
    cta_text: string;
    cta_link: string;
}

export interface IModelCarouselLoadRequest {
    variant?: EModelCarouselVariant | 'string';
    limit: number;
    ids: number[];
    category_id: number;
    verbosity?: number;
    isRecentlyViewed?: boolean;
    isRecentlyViewedItems?: number[];
}

export enum EModelCarouselVariant {
    CategoryProducts = 'category',
    ModelsIds = 'ids'
}
